import { useEffect } from 'react';
import { notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getNotificationsState } from '../../store/selectors';
import { CLOSE_NOTIFICATION } from '../../constants';

const NotificationsHandler = () => {
    const [api, contextHolder] = notification.useNotification();

    const state = useSelector(getNotificationsState);

    const dispatch = useDispatch();

    useEffect(() => {
        if (state?.show && state?.message) {
            const type = ['success', 'info', 'warning', 'error'].includes(state.status) ? state.status : 'info';
            api[type]({
                placement: 'topRight',
                message: state.message,
                duration: 3,
                closeIcon: null,
                onClose: () => dispatch({ type: CLOSE_NOTIFICATION }),
            });
        }
    }, [api, dispatch, state?.show, state?.message, state?.status]);

    return contextHolder;
};

export default NotificationsHandler;
